export const validateStatus = (status: number) => status >= 200;
